// Remove unused imports

import axios from 'axios';
import { BASE_URL, GOOGLE_BACKEND, APP_ID, APP_SECRET } from './authConfig';

interface UserProfile {
  googleId: string;
  imageUrl: string;
  email: string;
  name: string;
  givenName: string;
  familyName: string;
}

const getUserProfile = async (accessToken: string): Promise<UserProfile | undefined> => {
  try {
    const response = await axios.get('https://people.googleapis.com/v1/people/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        personFields: 'names,emailAddresses,photos',
      },
    });

    const data = response.data;
    console.log('Raw Google profile data:', data);
    
    // Check if we have photos data
    if (!data.photos || data.photos.length === 0) {
      console.warn('No photos found in Google profile data');
    } else {
      console.log('Available photos:', data.photos);
    }

    // Get the highest resolution photo URL and add necessary parameters
    const photoUrl = data.photos?.[0]?.url;
    if (!photoUrl) {
      console.warn('No photo URL found in Google profile data');
    } else {
      // Add size parameter to get a specific size and ensure proper access
      const imageUrl = `${photoUrl}?sz=100&access_token=${accessToken}`;
      console.log('Selected photo URL:', imageUrl);
    }
    
    const profile = {
      googleId: data.resourceName.split('/').pop(),
      imageUrl: photoUrl ? `${photoUrl}?sz=100&access_token=${accessToken}` : '',
      email: data.emailAddresses[0].value,
      name: data.names[0].displayName,
      givenName: data.names[0].givenName,
      familyName: data.names[0].familyName,
    };
    
    console.log('Processed profile data:', profile);
    return profile;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return undefined;
  }
};

export const handleGoogleLogin = async (accessToken: string): Promise<UserProfile | undefined> => {
  try {
    const userProfile = await getUserProfile(accessToken);
    if (!userProfile) {
      throw new Error('Failed to fetch user profile');
    }

    // Store auth data with Google token
    const now = new Date();
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('token_type', 'Bearer');
    localStorage.setItem('token_time', now.toUTCString());
    localStorage.setItem('user_profile', JSON.stringify(userProfile));
    
    // Set default permissions
    localStorage.setItem('permissions', JSON.stringify({
      isAuthenticated: true,
      canAccessPodcasts: true,
      canAccessInsights: true
    }));

    return userProfile;
  } catch (error) {
    console.error('Error during Google login:', error);
    throw new Error('Failed to log in with Google');
  }
}; 